@if (apiLoaded()) {
    <google-map height="100%" width="100%" [center]="center()" [options]="mapOptions" [zoom]="zoom()">
        @if (markerPosition()) {
            <map-advanced-marker [options]="markerOptions" [position]="markerPosition()" />
        }
    </google-map>
} @else {
    <div class="flex h-full w-full items-center justify-center bg-gray-100">
        <div role="status" class="text-neutral-20 text-body-small">
            {{ "supplier.loading_map" | transloco }}
            <span class="sr-only">{{ "supplier.loading_map_sr_only" | transloco }}</span>
        </div>
    </div>
}
